export const SortOptions =  [{ 
    id: 1,
    value : 'asc',
    name: 'Ascending'
  },
  {
    id: 2,
    value : 'desc',
    name: 'Descending'
  }
]


export interface SortInfo { 
    key: String,
    value: String
  }